




























import Vue from 'vue'

export default Vue.extend({
  props: {
    map: {
      type: Object,
      default: () => {
        return {
          center: {
            lat: 54,
            lng: -2,
          },
          zoom: 6
        }
      }
    },
    mapMarkers: {
      type: Array as () => Array<MapItem>,
      default: () => []
    },
    activeMarker: {
      type: Number,
      default: -1
    },
    infoWindowOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    }
  },

  methods: {
    onMarkerClick(marker, index) {
      this.$emit('selectMarker', marker, index)
    }
  },

  computed: {
    markers():MapItem[] { return this.mapMarkers }
  },
})
